import { gql } from 'apollo-angular';

export const GET_CROSS_REFERENCE_ASSIGNABLE_FIELDS = gql`
  query crossReferenceAssignableFields {
  crossReferenceAssignableFields {
    name
    required
    displayOrder
    displayName
    dataType
  }
}
`;

export default GET_CROSS_REFERENCE_ASSIGNABLE_FIELDS;
